import React, {useContext} from "react";

import Header from "../../components/Header";

import Questionarios from "../../components/Questionarios/listaQuestionarios";

import "./styles.css";

import {Context} from "../../AppProvider";

function TelaQuestionarios(props) {
    const appContext = useContext(Context);

    return (
        <Context.Consumer>
        {(context) => (
            <div>
            <Header usuario={context.usuario} videoajuda={props.videoajuda} />
            <Questionarios disponiveis="true" respondidos="true" membroCPA={context.membroCPA} questionarios={context.questionarios} questionariosModelos={context.questionariosModelos} escalasAvaliativa={appContext.escalasAvaliativa}/>
            </div>
        )}
        </Context.Consumer>
    );
}
export default TelaQuestionarios;
